module.exports = __webpack_public_path__ + "img/rca-rs-menu1.4d464b46.jpg";